
























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ModalWrapper from './ModalWrapper.vue';
import Dropdown from '@/components/shared/Dropdown.vue';
import { KeyringPair } from '@polkadot/keyring/types';
import { notificationTypes,  showNotification } from '@/utils/notification';
import exec from '@/utils/transactionExecutor';
import ViewTransaction from '../ViewTransaction.vue';
import { urlBuilderTransaction } from '@/utils/explorerGuide';

@Component({
	components: {
		ModalWrapper,
		Dropdown,
		ViewTransaction,
	},
})
export default class Second extends Vue {
	@Prop() public referendumId!: any;

	private account: any = {};
	private password: string = '';
	private vote: any = null;
	private tx: string = '';
	
  getExplorerUrl(value: string) {
    return urlBuilderTransaction(value, 
      this.$store.state.explorer.chain, 
      this.$store.state.explorer.provider)
  }

  public handleAccountSelection(account: KeyringPair) {
		this.account = account;
	}

	public handleVote(vote: boolean) {
		this.vote = vote;
	}

		public async shipIt() {
		const { api } = (this as any).$http;

		if (!api) {
			return;
		}
		
		try {
			showNotification('Dispatched');
			const { referendumId } = this;
			this.tx = await exec(this.account, this.password, api.tx.democracy.second, [referendumId]);
			showNotification(`Second ${referendumId.toString()}`, { ...notificationTypes.success, onAction: this.onAction() });
		} catch (e) {
			showNotification(e, notificationTypes.danger);
		}

	}

	public onAction() {
		return () => window.open(this.getExplorerUrl(this.tx), '_blank');
	}
  
}
